import React, { PropTypes } from 'react';
import AdviceItem from './AdviceItem';

const NoItem = () => (
  <div className="ui message">Aucun conseil. Veuillez en ajouter un</div>
);

const AdviceList = ({ advices, ...rest }) => {
  if (advices.length) {
    return (
      <div className="ui segment">
        <table className="ui very basic table">
          <tbody>
            {advices.map(advice => (
              <AdviceItem key={advice.id} advice={advice} {...rest} />
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  return <NoItem />;
};

AdviceList.propTypes = {
  advices: PropTypes.array.isRequired,
};

export default AdviceList;



// WEBPACK FOOTER //
// ./src/modules/funnel/components/detail/advices/AdviceList.js